/**
 * Landing on the exact item a link names (UX baseline): scrolled to, then marked briefly.
 * Shared by the tech's ticket card (the bell's link) and Settings' reply address (the
 * composer's link).
 */

/** How long an item landed on from a link stays marked: long enough to find, then quiet. */
export const LANDING_HIGHLIGHT_MS = 2500;

/**
 * The landing's scroll. The router scrolls to a `#hash` itself, but only to an element drawn
 * when it navigates: one drawn later (after its card's read) is the card's to reach.
 */
export const LANDING_SCROLL: ScrollIntoViewOptions = { block: 'start' };

/** The mark a landed item wears while it is lit (tokens, so both themes). */
export const LANDED_MARK =
  'rounded-[var(--radius)] bg-[var(--sw-brand-pill)] ring-2 ring-brand';
